export const names: string[] = [
  "Amy",
  "Bob",
  "Cindy",
  "Derek",
  "Emily",
  "Frank",
  "Glenda",
  "Harold",
  "India",
  "James",
  "Kelly",
  "Leroy",
  "Mandy",
  "Nathan",
  "Olivia",
  "Patrick",
  "Queen",
  "Roy",
  "Stacy",
  "Tom",
  "Uma",
  "Victor",
  "Wendy",
  "Xavier",
  "Yelena",
  "Zeb",
];

export const companies: string[] = [
  "TestCo",
  "Sample Co",
  "My Company",
  "Fama",
];
export const check_types: string[] = [
  "Sample One",
  "Sample Two",
  "Sample Three",
];
export const behavior_kits: string[] = ["General", "", "Custom 123"];

export function randomChoice<T>(values: T[]): T {
  return values[Math.floor(Math.random() * values.length)];
}
